import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TransferSkill, TransferAgent } from '../services/cxone-sdk.service';
import {
  executeSkillTransfer,
  executeAgentTransfer,
  executePhoneTransfer,
} from './transfer/transfer-action.handlers';

interface UseTransferActionsOptions {
  contactId: string;
  isConferenceMode: boolean;
  onComplete: (target?: string) => void;
}

export function useTransferActions({
  contactId,
  isConferenceMode,
  onComplete,
}: UseTransferActionsOptions) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const ctx = { contactId, isConferenceMode, onComplete, setError, setIsLoading, t };

  const handleSelectSkill = useCallback(
    (skill: TransferSkill) => executeSkillTransfer(ctx, skill),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contactId, isConferenceMode, onComplete, t]
  );

  const handleSelectAgent = useCallback(
    (agent: TransferAgent) => executeAgentTransfer(ctx, agent),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contactId, isConferenceMode, onComplete, t]
  );

  const handleDialPhone = useCallback(
    (phoneNumber: string) => executePhoneTransfer(ctx, phoneNumber),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contactId, isConferenceMode, onComplete, t]
  );

  const clearError = () => setError(null);

  return {
    isLoading,
    error,
    handleSelectSkill,
    handleSelectAgent,
    handleDialPhone,
    clearError,
  };
}
